import createSharedComposable from '@nicolaudie-group/ng-ui-kit/helpers/createSharedComposable'
import useStorage from '@nicolaudie-group/ng-ui-kit/composables/useStorage'

function useColorpickerSliderToggle() {
  return useStorage(
    'colorpicker-show-sliders',
    false,
    {
      serialize(value) { return value ? 1 : 0 },
      parse(value) { return Boolean.from(value) },
    },
  )
}

/*
Use a shared reactivity scope, so that changes made by a component to the value
are tracked between all other components using it within the same browser context
*/
export default createSharedComposable(useColorpickerSliderToggle)
